module.exports = __webpack_public_path__ + "img/museo_agua.8b61b316.png";